import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'

const SIDEBAR_MINIMISED_KEY = 'sidebar_minimised'
const SIDEBAR_MINIMISED_DEFAULT = false

export const SidebarTab = {
  REVIEW: 'review',
  ANNOTATIONS: 'annotations',
} as const

export type SidebarTab = (typeof SidebarTab)[keyof typeof SidebarTab]

export const useUIStore = defineStore('ui', () => {
  const workviewOverlayText = ref<string | null>(null)
  const sidebarMinimized = useLocalStorage(SIDEBAR_MINIMISED_KEY, SIDEBAR_MINIMISED_DEFAULT)

  const setSidebarMinimized = (minimized: boolean): void => {
    sidebarMinimized.value = minimized
  }

  const setWorkviewOverlayText = (text: string | null): void => {
    workviewOverlayText.value = text
  }

  const workviewSidebarTabs = ref<{ key: string }[]>([
    { key: SidebarTab.ANNOTATIONS },
    { key: SidebarTab.REVIEW },
  ])
  const workviewSidebarActiveTab = ref<string>(workviewSidebarTabs.value[0].key)

  const setWorkviewSidebarTab = (tabKey: string): void => {
    workviewSidebarActiveTab.value = tabKey
  }

  return {
    sidebarMinimized,
    setSidebarMinimized,

    workviewOverlayText,
    workviewSidebarTabs,
    workviewSidebarActiveTab,

    setWorkviewOverlayText,
    setWorkviewSidebarTab,
  }
})
